import React from "react";
import { Link } from "react-router-dom";
import { MdArrowForward, MdCheckCircle } from "react-icons/md";

import proptechTimesImage from "../../../assets/proptech_times_image.png";
import "./proptech_times_home.css";

const latestIssuePdf = "/the-proptech-times-2nd-edition.pdf";

const proptechTimesBenefits = [
  "Market intelligence from Pakistan's real estate ecosystem",
  "Stories and updates from PropTech Club members",
  "Insights on technology, investment, and property trends",
];

const PropTechTimesHome = () => {
  return (
    <section id="proptech_times_home_section" aria-labelledby="proptech_times_home_hdng">
      <div id="proptech_times_home_inner">
        <div id="proptech_times_home_visual" aria-hidden="true">
          <div id="proptech_times_home_cover_frame">
            <img src={proptechTimesImage} alt="" />
          </div>
        </div>

        <div id="proptech_times_home_copy">
          <h2 id="proptech_times_home_hdng">The PropTech Times</h2>
          <p id="proptech_times_home_txt">
            The PropTech Times is our quarterly publication for market intelligence, member stories,
            ecosystem updates, and real estate technology insights from across Pakistan.
          </p>
          <ul id="proptech_times_home_benefits">
            {proptechTimesBenefits.map((benefit) => (
              <li key={benefit}>
                <MdCheckCircle aria-hidden="true" />
                <span>{benefit}</span>
              </li>
            ))}
          </ul>
          <div id="proptech_times_home_actions">
            <a
              className="proptech_times_home_btn proptech_times_home_btn_primary"
              href={latestIssuePdf}
              target="_blank"
              rel="noopener noreferrer"
            >
              Read The Latest Issue
              <MdArrowForward aria-hidden="true" />
            </a>
            <Link className="proptech_times_home_btn proptech_times_home_btn_secondary" to="/proptech-times">
              View All Issues
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PropTechTimesHome;
